/* eslint-disable jsx-a11y/anchor-is-valid */
import "./brewpub-slider.scss";
import { useLang } from "../../helpers/language";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination } from "swiper/core";
import parse from "html-react-parser";

SwiperCore.use([Navigation]);
SwiperCore.use([Pagination]);
export default function BrewPubSlider({ cups, toggleCup, cupPage, config }) {
  const { lang } = useLang();
  return (
    <div id="brewpub-slider">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-md-4" >
            <h5 style={{fontWeight: 'bold', fontSize: '1.75em'}}>{cupPage ? cupPage.title? cupPage.title[lang] : '' : ''}</h5>
          </div>
          <div className="col-sm-7">
            {parse(cupPage ? cupPage.desc? cupPage.desc[lang] : '' : '')}
          </div>
        </div>
      </div>

      <div className="slider-wrapper">
        <button className={"swiper-button-prev d-none d-md-block"} aria-label="prev">
          <img src="/static/icons/arrow-white.svg" data-arrow="left" alt=""/>
        </button>
        <Swiper
          spaceBetween={0}
          slidesPerView={1}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          pagination={true}
          breakpoints={{
            1200: {
              slidesPerView: 4,
            },
            1080: {
              slidesPerView: 3,
            },
            768: {
              slidesPerView: 2,
            },
          }}
          // pagination={{ clickable: true }}
          // scrollbar={{ draggable: true }}
        >
          {cups.map((cup, index) => (
            <SwiperSlide key={index}>
              <div
                key={index}
                className="d-flex justify-content-center flex-wrap"
              >
                <img src={cup.uploads?`${config.api.API_URL}/${cup.uploads[0].path}`:null} alt="" width="100%" />
                <h6 className="w-100">{cup.title}</h6>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleCup(index);
                  }}
                >
                  {cup ? cup.name ? cup.name[lang] ? cup.name[lang] : 'Cupname' : 'Cupname' : 'Cupname' }
                </a>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <button className={"swiper-button-next d-none d-md-block"} aria-label="next">
          <img src="/static/icons/arrow-white.svg" data-arrow="right" alt="white"/>
        </button>
      </div>
    </div>
  );
}
